module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-minus-90f0a2e42554636ec705a7b4b645bdb4.svg";